import { render, staticRenderFns } from "./PublicHeader.vue?vue&type=template&id=d04ad49c&lang=pug&"
import script from "./PublicHeader.vue?vue&type=script&lang=js&"
export * from "./PublicHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports